import { createFileRoute } from '@tanstack/react-router'

import { getDateRangeFromPreset } from '@/lib/filter-helpers'
import { onDemandPaySearchSchema } from '@/lib/searchSchemas/onDemandPay'
import { advancesQueryOptions } from '@/queries/ewa'
import { AdvanceActivityParams } from '@/types/ewa'

export const Route = createFileRoute(
  '/_authenticated/account/_dashboard/onDemandPay/'
)({
  validateSearch: onDemandPaySearchSchema,
  loaderDeps: ({ search }) => search,
  loader: ({
    context: { queryClient },
    deps: { datePreset, fromDate, toDate },
  }) => {
    const { fromString, toString } = getDateRangeFromPreset({
      from: fromDate,
      to: toDate,
      presetId: datePreset,
    })

    const params: AdvanceActivityParams | undefined =
      fromString && toString ? { start: fromString, end: toString } : undefined

    return queryClient?.ensureInfiniteQueryData(advancesQueryOptions(params))
  },
})
